"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToJsonString = exports.addDate = exports.normalizeDate = exports.isDate = exports.parseMonth = void 0;
var moment_1 = __importDefault(require("moment"));
function parseMonth(value) {
    var splitted = value.split(/[年月.-]/);
    if (splitted.length < 2) {
        return null;
    }
    return (0, moment_1.default)("1900-01-01")
        .year(findYear(splitted[0]))
        .month(findMonth(splitted[1]) - 1)
        .toDate();
}
exports.parseMonth = parseMonth;
function findYear(value) {
    if (value.match(/令和元/)) {
        return 2019;
    }
    var num = Number(value.replace(/^[^\d]*([\d]+)[^\d]*$/, "$1"));
    if (value.match(/(平成|H)/)) {
        return 1988 + num;
    }
    else if (value.match(/(令和|R)/)) {
        return 2018 + num;
    }
    else if (num < 50) {
        return 2000 + num;
    }
    else if (num < 100) {
        return 1900 + num;
    }
    else {
        return num;
    }
}
function findMonth(value) {
    var num = Number(value.replace(/^[^\d]*([\d]+)[^\d]*$/, "$1"));
    if (num > 0 && num < 13) {
        return num;
    }
    else {
        return num;
    }
}
/**
 * Check if the value is `Date` or date stringified to JSON
 * @param value
 */
function isDate(value) {
    if (value instanceof Date) {
        return true;
    }
    else if (!(typeof value === "string")) {
        return false;
    }
    var d = Date.parse(value);
    if (isNaN(d)) {
        // moment が警告ださないように、timestamp に変換できるかは事前に確認
        return false;
    }
    else if (!value.match(/^\d{4}-\d{2}-\d{2}.*$/)) {
        // 年、年月などの日付を排除
        return false;
    }
    return (0, moment_1.default)(value).isValid();
}
exports.isDate = isDate;
var normalizeDate = function (date, span) {
    var md = (0, moment_1.default)(date);
    switch (span) {
        case "year":
            return md
                .set("month", 0)
                .set("date", 1)
                .set("hour", 0)
                .set("minute", 0)
                .set("second", 0)
                .set("millisecond", 0)
                .toDate();
        case "month":
            return md.set("date", 1).set("hour", 0).set("minute", 0).set("second", 0).set("millisecond", 0).toDate();
        case "date":
            return md.set("hour", 0).set("minute", 0).set("second", 0).set("millisecond", 0).toDate();
        default:
            return date;
    }
};
exports.normalizeDate = normalizeDate;
var addDate = function (date, amount, span) {
    var md = (0, moment_1.default)(date);
    switch (span) {
        case "year":
            return md.add(amount, "year").toDate();
        case "month":
            return md.add(amount, "month").toDate();
        case "date":
            return md.add(amount, "day").toDate();
        default:
            return date;
    }
};
exports.addDate = addDate;
var dateToJsonString = function (date) {
    var tmp = JSON.stringify(new Date(date));
    return tmp.replace(/^.*(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?(?:Z|[+-]\d{2}:\d{2})).*$/, "$1");
};
exports.dateToJsonString = dateToJsonString;
